// extracted by mini-css-extract-plugin
module.exports = {"saving":"Loader_saving__1KLHi","savingDots":"Loader_savingDots__3orG8","blink":"Loader_blink__69WPU","textCenter":"Loader_textCenter__1BLiC","iconColor":"Loader_iconColor__gDS4d"};